import { useEffect, useState } from "react";
import { BASE_URL } from "../helpers/constants";
import useApiRequest from "../helpers/api_request";
import { selectAccessToken } from "../features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { AxiosError } from "axios";
import { showToastMessage } from "../features/generalSlice";
import { toast } from "react-toastify";
import { formatDate } from "../helpers/commons";
import { TypeProductionData } from "../pages/production/CreateProductionPage";

const useProductionData = () => {
  const accessToken = useAppSelector(selectAccessToken);
  const [loadingData, setLoadingData] = useState(false);
  const [productionData, setProductionData] = useState<TypeProductionData[] | []>([]);
  const apiRequest = useApiRequest();
  const dispatch = useAppDispatch();


  const getProductionData = async () => {
    setLoadingData(true);
    await apiRequest({
      method: "get",
      url: BASE_URL + "/api/production",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setLoadingData(false);
        setProductionData(response.data);
      })
      .catch((error) => {
        const errorResponse = error as AxiosError;
        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string;
            status: string;
          };
          dispatch(
            showToastMessage({
              message: data.message,
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } else {
          dispatch(
            showToastMessage({
              message: "Something went wrong",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        }
        setLoadingData(false);
      });
  };

  return {
    loadingData,
    productionData,
    getProductionData,
  };
};

export default useProductionData;
